import {Mappings} from "./mappings";
import {schemaOf} from "@rezonence/schema-transformer";

export const mappingsSchema =  schemaOf<Mappings>();
